import { Component } from "@angular/core";
import { UserInfo } from "@corporate-tailwind/model";
import { AppSettingService, UserStore } from "@corporate-tailwind/store";
import { CorpPopMenuComponent } from "@corporate-tailwind/component";

@Component({
    selector: 'widget-user-app-shortcut',
    imports: [CorpPopMenuComponent],
    templateUrl: './user-app-shortcut.widget.html',
    styleUrl: './user-app-shortcut.widget.scss'
})
export class UserAppShortcutWidget {
    userInfo: UserInfo | null = null;
    menuOpen: boolean = false;
    hideImage: { [key: string]: boolean } = {};

    constructor(
        private _userStore: UserStore,
        public _appSettingService: AppSettingService
    ) {
    }

    ngOnInit(): void {
        this.userInfo = this._userStore.user()
    }

    toggleMenu() {
        this.menuOpen = !this.menuOpen
    }

}
